import React, {useState} from "react";
const phone = require("../assets/icon/phone_green_WEB_CHANGE_7.png");
const mail = require("../assets/icon/mail_green_WEB_CHANGE_7.png");

const ContactUs = () => {
  const [contact, setContact] = useState({
    fname: "",
    lname: "",
    number: "",
    email: "",
    message: "",
  });
  const [successMsg, setSuccessMsg] = useState('')
  const [showSpinner, setShowSpinner] = useState(false)

  const onTextChange = (e) => {
    const copyData = { ...contact };
    copyData[e.target.name] = e.target.value;
    if (e.target.name === "number" && copyData.number.length > 10) return;
    const hasValue = `error${e.target.name}`
    if(copyData[e.target.name]){
        delete copyData[hasValue]
    }
    setContact(copyData);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const copyData = { ...contact };
    let hasError = false
    if(!copyData.fname){
      hasError = true
      copyData[`errorfname`] = 'Please enter first name.'
    }
    if(!copyData.lname){
      hasError = true
      copyData[`errorlname`] = 'Please enter last name.'
    }
    if(!copyData.number){
      hasError = true
      copyData[`errornumber`] = 'Please enter contact number.'
    }
    if(!copyData.email){
      hasError = true
      copyData[`erroremail`] = 'Please enter email.'
    }
    if(!copyData.message){
      hasError = true
      copyData[`errormessage`] = 'Please enter message.'
    }
    if(copyData.number && copyData.number.length !== 10){
      hasError = true
      copyData[`errornumber`] = 'Please enter valid phone number.'
    }
    if(hasError){
      setContact(copyData);
      return
    }

    setShowSpinner(true)
    window.Email.send({
      SecureToken: '98808e90-1b9d-45d8-aa20-4d062333494d',
      Host: "smtp.gmail.com",
      Username: "beehives.pratik@gmail.com",
      Password: "Advik@1234%",
      To: "beehives.pratik@gmail.com",
      From: contact.email,
      Subject: "Contact Details",
      Body: `
      <b>First Name:</b> ${contact.fname} <br /> 
      <b>Last Name:</b> ${contact.lname} <br /> 
      <b>Email:</b> ${contact.email} <br /> 
      <b>Contact Number:</b> ${contact.number} <br /> 
      <b>Message:</b> ${contact.message} <br />`,
    }).then(function () {      
      setContact({
        fname: "",
        lname: "",
        number: "",
        email: "",
        message: "",
      })
      setSuccessMsg("mail sent successfully.")
      setShowSpinner(false)
      setTimeout(() => {
        setSuccessMsg("")
      }, 2000)
    });
  };

  return (
    <>
      <div className="row" style={{ padding: "5px" }}></div>
      <div className="container contact-us-wrapper">
        <h3 className="font-bold contact-text poppins-bold">Contact Us</h3>
        <div className="contact-us-form row">
          <div className="col-md-8 col-sm-12 form-padd-right">
            <form onSubmit={onSubmit} method="post" encType="text/plain">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="fname">First Name <span className="error_msg">*</span></label>
                    <input
                      type="text"
                      value={contact.fname}
                      id="fname"
                      onChange={(e) => onTextChange(e)}
                      className="form-control"
                      placeholder="First Name"
                      name="fname"
                    />
                    <div className="error_msg">{contact.errorfname}</div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="lname">Last Name <span className="error_msg">*</span></label>
                    <input
                      type="text"
                      value={contact.lname}
                      className="form-control"
                      onChange={(e) => onTextChange(e)}
                      id="lname"
                      placeholder="Last Name"
                      name="lname"
                    />
                    <div className="error_msg">{contact.errorlname}</div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="emailAdd">Email Address <span className="error_msg">*</span></label>
                    <input
                      type="email"
                      value={contact.email}
                      id="emailAdd"
                      onChange={(e) => onTextChange(e)}
                      className="form-control"
                      placeholder="Enter Email"
                      name="email"
                    />
                    <div className="error_msg">{contact.erroremail}</div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="num">Contact Number <span className="error_msg">*</span></label>
                    <input
                      type="number"
                      value={contact.number}
                      className="form-control"
                      onChange={(e) => onTextChange(e)}
                      id="num"
                      placeholder="Enter Number"
                      name="number"
                    />
                    <div className="error_msg">{contact.errornumber}</div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="msg">Message <span className="error_msg">*</span></label>
                    <textarea
                      className="form-control"
                      name="message"
                      id="msg"
                      value={contact.message}
                      onChange={(e) => onTextChange(e)}
                      rows="4"
                      placeholder="Enter Message"
                    ></textarea>
                    <div className="error_msg">{contact.errormessage}</div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <button type="submit" className="btn btn-default btn-submit" disabled={showSpinner}>
                  {showSpinner ? <span className="spinner-border spinner-border-sm spinner_mrg" role="status" aria-hidden="true"></span> : null}
                  <span>Submit</span>
                </button>
              </div>
              {successMsg ? <div className="success-msg">{successMsg}</div> : null}
            </form>
          </div>
          <div className="col-md-4 col-sm-12 contact-info padd_top_sm">
            <div className="col">
              <label>Contact:</label>
              <p>
                <img src={phone} width="20" alt="Phone" /> +91-8482858740
              </p>
              <label>Email Us:</label>
              <p>
                <img src={mail} width="20" alt="Email" /> info@beehives.co.in
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
